import { map } from "rxjs/operators";
import { POST, PUT } from "../../../module/services/fetch";

export const fetchSupervisorsAndRevisorsRequest = (request: any) => {
  const req = {
    ...(request ? request : {}),
  };
  // w1 - project metro 
  return POST("admin/user/find", req).pipe(map((response: any) => response));
};

export const fetchUsersRequest = (request: any = {}) => {
  const req = request ? request : {};
  // w1 - project metro 
  return POST("admin/user/find", req).pipe(map((response: any) => response));
};

export const fetchGroupsRequest = (request: any = {}) => {
  const req = request ? request : {};
  return POST("ou/find", req).pipe(map((response: any) => response));
};

export const fetchApplicationsRequest = (request: any = {}) => {
  const req = request ? request : {};
  return POST("application/find", req).pipe(map((response: any) => response));
};

export const fetchBRRequest = (request: any = {}) => {
  const req = request ? request : {};

  return POST("businessRole/find", req).pipe(map((response: any) => response));
};

export const fetchEntitlementsRequest = (request: any = {}) => {
  const req = request ? request : {};

  return POST(`entitlements`, req).pipe(map((response: any) => response));
};

export const createCertificationRequest = (request: any = {}) =>
  POST("recertification/v1/configuration", request).pipe(
    map((response: any) => response)
  );

export const editCertificationRequest = (request: any = {}) =>
  PUT("recertification/v1/configurations", request).pipe(
    map((response: any) => response)
  );
